import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ask_for_recommendation = _resolveComponent("ask-for-recommendation")!
  const _component_recommendation_side = _resolveComponent("recommendation-side")!
  const _component_step = _resolveComponent("step")!

  return (_openBlock(), _createBlock(_component_step, {
    "is-step-valid": _ctx.hasValidFieldPart,
    "show-skip-step": true,
    "is-loading": _ctx.isLoadingButtonNext,
    "is-skip-enabled": _ctx.data.recoEmails.length === 0,
    onGoToNext: _ctx.goNext
  }, {
    "step-content": _withCtx(() => [
      _createVNode(_component_ask_for_recommendation, {
        onEmailsChanged: _ctx.changeRecoEmails,
        onTextChanged: _ctx.changeRecoText
      }, null, 8, ["onEmailsChanged", "onTextChanged"])
    ]),
    "step-side": _withCtx(() => [
      _createVNode(_component_recommendation_side)
    ]),
    _: 1
  }, 8, ["is-step-valid", "is-loading", "is-skip-enabled", "onGoToNext"]))
}